export enum VariableTypes {
  object = 'object',
  string = 'string'
}
